export const saveToLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export function getFromLocalStorage(key: string): string {
  // @ts-ignore
  return localStorage.getItem(key);
}

export const removeFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};
